import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const notificationsModule = {
  namespaced: true,
  state() {
    return {};
  },
  actions,
  getters,
  mutations,
};

export default notificationsModule;
